<template>
  <div>
    <h4 class="text-center mt-4 mb-3">Dane do faktury</h4>

    <!-- Data exists -->
    <template v-if="hasInvoiceData">
      <table class="table invoice-table">
        <thead>
          <tr class="tr-gradient">
            <th>Podmiot</th>
            <th>Nazwa</th>
            <th>Dane identyfikacyjne</th>
            <th>Ulica</th>
            <th>Numer budynku</th>
            <th>Numer lokalu</th>
            <th>Kod pocztowy</th>
            <th>Miejscowość</th>
            <th>Działania</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ isCompany ? "Firma" : "Osoba prywatna" }}</td>
            <td>{{ displayName }}</td>
            <td>
              <template v-if="isCompany">
                <strong>NIP:</strong> {{ f('company_nip') }}<br />
                <strong>REGON:</strong> {{ f('company_regon') || "-" }}<br />
                <strong>KRS:</strong> {{ f('company_krs') || "-" }}
              </template>
              <template v-else>-</template>
            </td>
            <td>{{ f('street_invoice') || "Brak" }}</td>
            <td>{{ f('number1_invoice') || "Brak" }}</td>
            <td>{{ f('number2_invoice') || "Brak" }}</td>
            <td>{{ f('postcode_invoice') || "Brak" }}</td>
            <td>{{ f('city_invoice') || "Brak" }}</td>
            <td>
              <button
                class="btn btn-sm btn-outline-dark mb-1 d-block action-btn"
                @click="openEditModal"
              >Edytuj dane</button>
              <button
                class="btn btn-sm btn-outline-danger d-block action-btn"
                @click="openDeleteModal"
              >Usuń dane</button>
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <!-- No data -->
    <template v-else>
      <div class="text-center my-3">
        <button class="btn btn-outline-dark" @click="openAddModal">
          DODAJ DANE DO FAKTURY
        </button>
      </div>
    </template>

    <!-- Hidden triggers for modals -->
    <button ref="addTrigger" data-toggle="modal" :data-target="`#addInvoice-${uniqueId}`" style="display: none;"></button>
    <button ref="editTrigger" data-toggle="modal" :data-target="`#editInvoice-${uniqueId}`" style="display: none;"></button>
    <button ref="deleteTrigger" data-toggle="modal" :data-target="`#deleteInvoice-${uniqueId}`" style="display: none;"></button>

    <!-- Add modal -->
    <InvoiceDataModal
      :modalId="`addInvoice-${uniqueId}`"
      :profile="null"
      :userId="userId"
      :editMode="false"
      :fieldPrefix="fieldPrefix"
      @saved="$emit('updated')"
    />

    <!-- Edit modal -->
    <InvoiceDataModal
      :modalId="`editInvoice-${uniqueId}`"
      :profile="profile"
      :userId="userId"
      :editMode="true"
      :fieldPrefix="fieldPrefix"
      @saved="$emit('updated')"
    />

    <!-- Delete confirm modal -->
    <InvoiceDeleteConfirmModal
      :modalId="`deleteInvoice-${uniqueId}`"
      @confirm="deleteInvoiceData"
    />
  </div>
</template>

<script>
import InvoiceDataModal from "./InvoiceDataModal.vue";
import InvoiceDeleteConfirmModal from "./InvoiceDeleteConfirmModal.vue";
import axios from "../axios";

export default {
  name: "InvoiceDataSection",
  components: { InvoiceDataModal, InvoiceDeleteConfirmModal },
  props: {
    profile: { type: Object, default: null },
    userId: { type: String, default: "" },
    fieldPrefix: { type: String, default: "" },
  },
  emits: ["updated"],
  computed: {
    uniqueId() {
      return (this.fieldPrefix || "") + (this.userId || "default");
    },
    hasInvoiceData() {
      return this.profile && (this.f('postcode_invoice') || this.f('company_name') || this.f('first_name_invoice'));
    },
    isCompany() {
      const type = this.f('invoice_type');
      if (type) return type === "COMPANY";
      return !!this.f('company_name');
    },
    displayName() {
      if (this.isCompany) {
        return this.f('company_name') || "";
      }
      return `${this.f('first_name_invoice') || ""} ${this.f('last_name_invoice') || ""}`.trim() || "Brak";
    },
    deleteEndpoint() {
      if (this.fieldPrefix === "customer_") {
        return `/api/admin/profile/${this.userId}/customerInvoiceAddress`;
      }
      return `/api/admin/profile/${this.userId}/invoiceAddress`;
    },
  },
  methods: {
    f(field) {
      if (!this.profile) return null;
      return this.profile[this.fieldPrefix + field];
    },
    openAddModal() {
      this.$refs.addTrigger.click();
    },
    openEditModal() {
      this.$refs.editTrigger.click();
    },
    openDeleteModal() {
      this.$refs.deleteTrigger.click();
    },
    async deleteInvoiceData() {
      try {
        await axios.delete(this.deleteEndpoint);
        this.$notify({ group: "success", text: "Dane do faktury zostały usunięte" });
        this.$emit("updated");
      } catch (err) {
        this.$notify({ group: "error", text: "Nie udało się usunąć danych" });
      }
    },
  },
};
</script>

<style scoped>
.invoice-table {
  font-size: 14px;
}
.tr-gradient {
  background: linear-gradient(90deg, #fb8928 0%, #e50582 100%);
  color: white;
}
.tr-gradient th {
  font-weight: 600;
  font-size: 13px;
  border: none;
}
.action-btn {
  width: 120px;
}
</style>
